<template>
  <div class="left-chart-2">
    <dv-scroll-board :config="list" class="lc3-chart" @click="handleBoardClick" />
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'LayoutLeft2',
  data () {
    return {
        list: {
            data: []
        },
        cityRows: [],
        activeRowIndex: -1
    }
  },
  computed: {

  },
  mounted: function () {
    this.loadList()
  },
    methods: {
        warpTxt(txt, warp, active) {
            if (active) {
                return '<span style="color: #ffd166; font-weight: 700;">' + txt + '</span>'
            }

            if (warp) {
                return '<span style="color: #f00;">' + txt + '</span>'
            }
            return txt
        },
        buildList() {
            var that = this;
            var list = {
                header: ['\u57ce\u5e02', '\u573a\u6b21', '\u4eba\u6570'],
                rowNum: 10,
                columnWidth: [50, 140, 70, 90],
                index: true,
                align: 'left',
                data: []
            };

            this.cityRows.forEach((element, i) => {
                var isActive = i === that.activeRowIndex
                list.data.push([
                    that.warpTxt(element.city_text, i < 3, isActive),
                    that.warpTxt(element.scene, i < 3, isActive),
                    that.warpTxt(element.attendance, i < 3, isActive)
                ])
            });

            this.list = list
        },
        handleBoardClick({ rowIndex }) {
            const city = this.cityRows[rowIndex]
            if (!city) {
                return
            }

            this.activeRowIndex = rowIndex
            this.buildList()
            this.$emit('click-city', city)
        },
        loadList() {
            var that = this;
            axios.get(this.$store.state.config.host + "/big/whole/")
            .then(response => {
                var cityRows = [];
                Object.values(response.data.data.city).forEach(element => {
                    cityRows.push(element)
                });
                that.cityRows = cityRows;
                that.buildList();
            })
        }
    }
}
</script>

<style lang="less">
.left-chart-2 {
  width: 100%;
  height: 88%;
  display: flex;
  flex-direction: column;

  .lc1-header {
    text-align: center;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 30px;
    margin-bottom: 20px;
  }

  .lc3-chart {
    flex: 1;
    font-size: 16px;
    span {
        font-size: 20px;
    }
    div {
        font-size: 16px;
    }
  }
}
</style>
